var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextContentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.955 4.04505C22.0647 6.15483 23.25 9.01631 23.25 12C23.25 14.9837 22.0647 17.8452 19.955 19.9549C17.8452 22.0647 14.9837 23.25 12 23.25C9.01632 23.25 6.15483 22.0647 4.04505 19.955C1.93526 17.8452 0.75 14.9837 0.749999 12C0.749999 9.01631 1.93526 6.15483 4.04505 4.04505C6.15483 1.93526 9.01631 0.749998 12 0.749998C14.9837 0.749997 17.8452 1.93526 19.955 4.04505Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 16.5023L18.5002 12.0023L14.0002 7.50232",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.0027L18.5 12.0027",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextContentIcon);
export default __webpack_public_path__ + "static/media/next-content-icon.fdb122e9fa6a72ee489c2bc9d8500850.svg";
export { ForwardRef as ReactComponent };